/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProviderLightDto
 */
export interface ProviderLightDto {
    /**
     * Provider ID
     * @type {string}
     * @memberof ProviderLightDto
     */
    providerId: string;
    /**
     * Provider name
     * @type {string}
     * @memberof ProviderLightDto
     */
    providerName: string;
    /**
     * Provider email
     * @type {string}
     * @memberof ProviderLightDto
     */
    providerEmail: string;
}

/**
 * Check if a given object implements the ProviderLightDto interface.
 */
export function instanceOfProviderLightDto(value: object): value is ProviderLightDto {
    if (!('providerId' in value) || value['providerId'] === undefined) return false;
    if (!('providerName' in value) || value['providerName'] === undefined) return false;
    if (!('providerEmail' in value) || value['providerEmail'] === undefined) return false;
    return true;
}

export function ProviderLightDtoFromJSON(json: any): ProviderLightDto {
    return ProviderLightDtoFromJSONTyped(json, false);
}

export function ProviderLightDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProviderLightDto {
    if (json == null) {
        return json;
    }
    return {
        
        'providerId': json['providerId'],
        'providerName': json['providerName'],
        'providerEmail': json['providerEmail'],
    };
}

export function ProviderLightDtoToJSON(json: any): ProviderLightDto {
    return ProviderLightDtoToJSONTyped(json, false);
}

export function ProviderLightDtoToJSONTyped(value?: ProviderLightDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'providerId': value['providerId'],
        'providerName': value['providerName'],
        'providerEmail': value['providerEmail'],
    };
}

